import { useSelector } from "react-redux";

export const useHasEditPermission = () => {
  const userData = useSelector((state) => state.token.userData);
  let permission = userData?.permission || "";
  return permission.includes("write");
};

export const useHasUploadPermission = () => {
  const userData = useSelector((state) => state.token.userData);
  let permission = userData?.permission || "";
  return permission.includes("upload");
};
